// export const BASE_URL_USER_SERVICE = "https://dev.pyramidcafe.com:8443/userservice_v2/"
// export const BASE_URL_INVENTORY = "https://dev.pyramidcafe.com:8443/InventoryService/"

// const BASE_URL_USER_SERVICE = "https://erp.pyramidcafe.com:8443/userservice_v2/";
// export const BASE_URL_INVENTORY = "https://erp.pyramidcafe.com:8443/InventoryService/";

// const BASE_URL_USER_SERVICE = "https://user-api-erp.pyramidcafe.com/";
// export const BASE_URL_INVENTORY = "https://api-erp.pyramidcafe.com/";

// Abul Sir's Server
// const BASE_URL_USER_SERVICE = "http://192.168.1.187:8002/";
// export const BASE_URL_INVENTORY = "http://192.168.1.187:8098/";


const BASE_URL_USER_SERVICE = process.env.REACT_APP_BASE_URL_USER_SERVICE
export const BASE_URL_INVENTORY = process.env.REACT_APP_BASE_URL_INVENTORY
 

export const DOWNLOAD_ITEM_URL = "items/downloadItemExcel/";
export const DOWNLOAD_VENDOR_URL = "vendor/downloadVendorExcel";
export const DOWNLOAD_CUSTOMER_URL = "customer/downloadCustomerExcel";
export const DOWNLOAD_ITEM_PRICE_URL = "itemPriceList/downloadItemPriceExcel/";
export const UPLOAD_ITEM_PRICE_URL = "itemPriceList/uploadItemPriceExcel/";


export const LOGIN_URL = () => BASE_URL_USER_SERVICE + "login";
export const GENERATEOTP_URL = () => BASE_URL_USER_SERVICE + "generateOtp";
export const VERIFYOTP_URL = () => BASE_URL_USER_SERVICE + "verifyOtp";
export const REQUEST_PUBLIC_KEY = () => BASE_URL_USER_SERVICE + "admin/requestPublicKey";

// url
export const URL = () => BASE_URL_USER_SERVICE + "url/";
export const URL_MAPPING = () => BASE_URL_USER_SERVICE + "urlMapping/";
export const DEF_URL_MAPPING = () => BASE_URL_USER_SERVICE + "defaultRoleUrlMapping/";
export const MODULE_URL = () => BASE_URL_USER_SERVICE + "module/";
export const USER_CUSTOMER_URL = () => BASE_URL_INVENTORY + "userCustomer/";

// inventory
export const ALL_ITEM_URL = () => BASE_URL_INVENTORY + "items/getAllRecords";
export const ITEM_DETAIL_BY_UUID = () => BASE_URL_INVENTORY + "items/UUID/";
export const ITEM_URL = () => BASE_URL_INVENTORY + "items/";
export const PRICE_URL = () => BASE_URL_INVENTORY + "itemPriceList/";
export const ISSUANCE_URL = () => BASE_URL_INVENTORY + "issuance/";
export const RETURN_ISSUANCE_URL = () => BASE_URL_INVENTORY + "return-issuance/";

// sales
export const EINVOICE_URL = () => BASE_URL_INVENTORY + "eInvoice/";
export const INVOICES_URL = () => BASE_URL_INVENTORY + "invoice/";
export const PAYMENT_URL = () => BASE_URL_INVENTORY + "recordPayment/";
export const SALE_ORDER_URL = () => BASE_URL_INVENTORY + "salesOrder/";
export const CUSTOMER_URL = () => BASE_URL_INVENTORY + "customer/";
export const CREDIT_NOTE_URL = () => BASE_URL_INVENTORY + "creditNote/";
export const CREDIT_NOTE_HISTORY_URL = () => BASE_URL_INVENTORY + "logCreditNoteHistory/"

// purchase
export const TDS_URL = () => BASE_URL_INVENTORY + "tds/";
export const VENDOR_URL = () => BASE_URL_INVENTORY + "vendor/";
export const PURCHASE_URL = () => BASE_URL_INVENTORY + "purchaseOrder/";
export const BILL_URL = () => BASE_URL_INVENTORY + "bill/";
export const PURCHASE_PAYMENT_URL = () => BASE_URL_INVENTORY + "purchaseRecordPayment/";
export const DEBIT_NOTE_URL = () => BASE_URL_INVENTORY + "debitNote/";
export const DEBIT_NOTE_HISTORY_URL = () => BASE_URL_INVENTORY + "logDebitNoteHistory/";
// production
export const RECIPE_URL = () => BASE_URL_INVENTORY + "recipe/";
export const BATCH_URL = () => BASE_URL_INVENTORY + "batches/";
export const REQUISITION_URL = () => BASE_URL_INVENTORY + "requisition/";

export const REQUISITION_LOG_URL = () => BASE_URL_INVENTORY + "logRequisitionHistory/";
export const PRODUCTION_DETAILS_URL = () => BASE_URL_INVENTORY + "production_details_status/";
export const REQUISITION_KEY_VALUE_LIST_URL = () => BASE_URL_INVENTORY + "getKeyValueDetailForRequisition";

// log

export const LOG_ITEM_TRANSACTION_URL = () => BASE_URL_INVENTORY + "logItemTransaction/";
export const LOG_ITEM_HISTORY_URL = () => BASE_URL_INVENTORY + "logItemHistory/";
export const SALES_ORDER_LOG_URL = () => BASE_URL_INVENTORY + "logSalesOrderHistory/";
export const INVOICE_LOG_URL = () => BASE_URL_INVENTORY + "logInvoiceHistory/";

// tax
export const TAX_EXEMPTION_URL = () => BASE_URL_INVENTORY + "taxExemption/";
export const TAX_URL = () => BASE_URL_INVENTORY + "tax/";
export const TAX_GROUP_URL = () => BASE_URL_INVENTORY + "taxGroup/";

// warehouse
export const WAREHOUSE_URL = () => BASE_URL_INVENTORY + "warehouse/";
export const WAREHOUSEITEM_URL = () => BASE_URL_INVENTORY + "warehouseItems/";
export const WAREHOUSE_VENDOR_URL = () => BASE_URL_INVENTORY + "warehouseVendor/";
export const GET_ALL_ITEMS_FOR_ISSUANCE_POST = () => WAREHOUSE_URL() + "getAllActiveRecordsByWarehouseIdAndDepartmentId";

// others

export const ROUND_OFF_URL = () => BASE_URL_INVENTORY + "roundOff/";
export const CURRENCY_URL = () => BASE_URL_INVENTORY + "currency/";
export const GST_TREATMENT_URL = () => BASE_URL_INVENTORY + "gstTreatment/";
export const COUNTRY_URL = () => BASE_URL_INVENTORY + "country/";
export const STATE_REGION_URL = () => BASE_URL_INVENTORY + "stateRegion/";
export const SALE_PERSON_URL = () => BASE_URL_INVENTORY + "salesPerson/";
export const IMAGE_UPLOAD_URL = () => BASE_URL_USER_SERVICE + "file/";
export const ADMIN_URL = () => BASE_URL_USER_SERVICE + "admin/";
export const ADMIN_URL2 = () => BASE_URL_INVENTORY + "admin/";
export const COMMON_URL = () => BASE_URL_INVENTORY + "common/";
export const BRAND_URL = () => BASE_URL_INVENTORY + "brand/";
export const DELIVERY_METHOD_URL = () => BASE_URL_INVENTORY + "deliveryMethod/";
export const PAYMENT_TERM_URL = () => BASE_URL_INVENTORY + "paymentTerms/";
export const UNIT_URL = () => BASE_URL_INVENTORY + "units/";
export const HSN_URL = () => BASE_URL_INVENTORY + "hsn/";
export const QUALITYPARAMETER_URL = () => BASE_URL_INVENTORY + "QualityParameter/";
export const MANUFACTRUER_URL = () => BASE_URL_INVENTORY + "manufacturer/";
export const ACCOUNT_URL = () => BASE_URL_INVENTORY + "account/";
export const ORGANISATION_SETTING_URL = () => BASE_URL_INVENTORY + "settings/";
export const PAYMENT_MODE_URL = () => BASE_URL_INVENTORY + "paymentModes/";
export const DELIVERY_URL = () => BASE_URL_INVENTORY + "deliveryPerson/";
export const ORGANISATION_URL = () => BASE_URL_USER_SERVICE + "organisation/";
export const TERMSCONDITION_URL = () => BASE_URL_INVENTORY + "termsCondition/";
export const DEPARTMENT_URL = () => BASE_URL_INVENTORY + "department/";
export const ADDRESS_URL = () => BASE_URL_INVENTORY + "address/";

export const GENERATE_EWAY_GET = () => BASE_URL_INVENTORY + "eWay/generateEWay/";
export const GET_ALL_CATEGORIES_POST = () => BASE_URL_INVENTORY + "category/getAllRecords";
export const CATEGORY_URL = () => BASE_URL_INVENTORY + "category/";

export const CUSTOMER_CATEGORY_URL = () => BASE_URL_INVENTORY + "customerCategory/";
export const VENDOR_CATEGORY_URL = () => BASE_URL_INVENTORY + "vendorCategory/";
export const SUB_CATEGORY_URL = () => BASE_URL_INVENTORY + "subCategory/";

// Stock Closing
export const STOCK_CLOSING_URL = () => BASE_URL_INVENTORY + "stockClosing/";
export const DEP_STOCK_CLOSING_URL = () => BASE_URL_INVENTORY + "departmentStockClosing/";
export const WASTAGE_BASE_URL = () => BASE_URL_INVENTORY + "wastage/";
export const WASTAGE_URL = () => WASTAGE_BASE_URL() + "warehouseList/";
export const POST_WASTAGE_NEW = BASE_URL_INVENTORY + "wastage/"
export const DEP_LOG_STOCK = () => BASE_URL_INVENTORY + "logDepartmentStockClosing/";

// stock transfer
export const STOCK_TRANSFER_URL = () => BASE_URL_INVENTORY + "stockTransfer/";
export const STOCK_TRANSFER_NEW = BASE_URL_INVENTORY + "logStockTransfer/"


// Reports
export const REPORTS_URL = BASE_URL_INVENTORY + "reports/";
export const RESTAURANT_REPORTS_URL = BASE_URL_INVENTORY + "restaurantReports/";
export const DASHBOARD_URL = BASE_URL_INVENTORY + "dashboard/";

// Store
export const STORE_BASE_URL = () => BASE_URL_INVENTORY + "store/";

// Tcs
export const TCS_BASE_URL = () => BASE_URL_INVENTORY + "tcs/";

//Rack
export const RACK_BASE_URL = () => BASE_URL_INVENTORY + "rack/";

//Cell
export const CELL_BASE_URL = () => BASE_URL_INVENTORY + "cell/";

//Pallet
export const PALLET_BASE_URL = () => BASE_URL_INVENTORY + "pallet/";

// Store to Store transfer (inside one warehouse)
export const STORE_TRANSFER_URL = () => BASE_URL_INVENTORY + "storeTransfer/";

export const POST_GET_ALL_ITEMS_POST = BASE_URL_INVENTORY + "warehouseItems/getAllActiveRecordsByWarehouseIdAndDepartmentId";

export const GET_WAREHOUSE_BY_ORG_ID = BASE_URL_INVENTORY + "warehouse/getKeyValueListByOrganisation/{uuid}";

// Update E-way Vehicle number
export const UPDATE_EWAY_VEHICLE_NUMBER_POST = BASE_URL_INVENTORY + "eWay/updateVehicleNumber/{invoiceNo}";
export const CANCEL_EWAY_BILL_POST = BASE_URL_INVENTORY + "eWay/cancelEWay/{invoiceNo}";

export const EXTEND_EWAY_BILL_POST = + BASE_URL_INVENTORY + "eWay/generateExtendedEwayBill/{invoiceNo}";

//restaurant report controller
export const restaurant_report_List_GET = () => BASE_URL_INVENTORY + "restaurantSales/restaurant/list";
export const restaurant_department_List = BASE_URL_INVENTORY + "restaurantSales/department/getKeyValueList";
export const restaurant_report_wip_POST = BASE_URL_INVENTORY + "restaurantReports/wip"
export const requisitionReport_POST = BASE_URL_INVENTORY + "reports/requisitionReport"

export const restaurentReportDailyConsumption = BASE_URL_INVENTORY + "restaurantReports/ingredientReport"
export const stockHistory_Report = BASE_URL_INVENTORY + "stockHistory/stock-history-date"

export const QC_USER_URL = BASE_URL_USER_SERVICE + "admin/list/qc-users"